"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSubmittedClaimSchema = exports.submittedClaimSchema = void 0;
var constants_1 = require("@hobt/constants");
var schema_validator_1 = require("@hobt/schema-validator");
var common_1 = require("../common");
var borrower_charges_1 = require("./borrower-charges");
var borrower_details_1 = require("./borrower-details");
var constants_2 = require("../constants");
var default_management_1 = require("./default-management");
var detail_1 = require("./detail");
var indicator_1 = require("./indicator");
var lender_1 = require("./lender");
var listing_1 = require("./listing");
var net_operating_income_rental_income_1 = require("./net-operating-income-rental-income");
var partial_payment_1 = require("./partial-payment");
var property_1 = require("./property");
var validation_result_1 = require("./validation-result");
exports.submittedClaimSchema = {
    type: 'object',
    required: [
        'approvedLenderFinancialInstitutionCode',
        'approvedLenderReferenceNumber',
        'approvedLenderTransitNumber',
        'claimTypeIndicator',
        'cmhcLoanAccountNumber',
        'exceptionToListingFlag',
        'partialPaymentReceivedFlag',
        'rentalIncomeReceivedFlag',
        'borrowers',
        'defaultManagement',
        'detail',
        'lender',
        'listings',
        'property',
    ],
    properties: {
        approvedLenderFinancialInstitutionCode: {
            type: 'string',
            minLength: 3,
            maxLength: 3,
            errorMessage: 'Should be a string with 3 characters',
        },
        approvedLenderReferenceNumber: {
            type: 'string',
            minLength: 0,
            maxLength: 20,
            errorMessage: 'Should be a string with a maximum of 20 characters',
        },
        approvedLenderTransitNumber: {
            type: 'string',
            minLength: 5,
            maxLength: 5,
            errorMessage: 'Should be a string with 5 characters',
        },
        attachments: {
            type: ['array', 'null'],
            minItems: 0,
            maxItems: 50,
            items: common_1.attachmentSchema,
            errorMessage: 'Should be an array of Attachments with maximum 50 attachments',
        },
        claimBusinessID: {
            type: 'string',
            minLength: 0,
            maxLength: 30,
            errorMessage: 'Should be a string with a maximum of 30 characters',
        },
        claimID: {
            type: ['string', 'null'],
            format: 'uuid',
            errorMessage: 'Should follow UUID format 00000000-0000-0000-0000-000000000000 or null',
        },
        claimTypeIndicator: {
            type: 'number',
            enum: Object.values(constants_2.ClaimTypeIndicator),
            errorMessage: 'Should equate to a valid ClaimTypeIndicator Enum value',
        },
        cmhcLoanAccountNumber: {
            type: 'number',
            minimum: 10000000,
            maximum: 99999999,
            errorMessage: 'Should be a numeric value with 8 digits',
        },
        exceptionToListingFlag: {
            type: ['boolean', 'string'],
            enum: [true, false, 'true', 'false'],
            errorMessage: 'should be true or false',
        },
        partialPaymentReceivedFlag: {
            type: ['boolean', 'string'],
            enum: [true, false, 'true', 'false'],
            errorMessage: 'should be true or false',
        },
        rentalIncomeReceivedFlag: {
            type: ['boolean', 'string'],
            enum: [true, false, 'true', 'false'],
            errorMessage: 'should be true or false',
        },
        sequenceNumber: {
            type: 'number',
            minimum: 0,
            maximum: 2147483647,
            errorMessage: 'Should be an integer between 0 and 2147483647',
        },
        validationResult: validation_result_1.validationResultSchema,
        indicator: indicator_1.indicatorExtendedSchema,
        lender: lender_1.lenderSchema,
        borrowers: {
            type: 'array',
            items: borrower_details_1.borrowerDetailsExtendedSchema,
            minItems: 1,
            maxItems: 10,
        },
        property: __assign(__assign({}, property_1.propertySchema), { isValidPropertyBedCountUnitCount: true }),
        defaultManagement: default_management_1.defaultManagementExtendedSchema,
        detail: detail_1.detailExtendedSchema,
        listings: {
            type: 'array',
            items: listing_1.listingExtendedSchema,
            minItems: 1,
            isAfterFirstListingDate: ['appraisalDate', 'comparativeMarketAnalysisDate', 'date'],
            isLessThanFirstListingAmount: ['revisedPriceAmount'],
        },
        borrowerCharges: {
            type: ['array', 'null'],
            items: borrower_charges_1.borrowerChargesExtendedSchema,
            isAfterLastCompleteInstallmentPaidDueDate: {
                $data: '1/detail/receivedLastCompleteInstallmentPaidDueDate',
            },
        },
    },
    allOf: [
        {
            if: {
                required: ['indicator'],
                properties: {
                    indicator: {
                        required: ['claimReceivedDate'],
                    },
                },
            },
            then: {
                required: ['borrowers'],
                properties: {
                    borrowers: {
                        type: ['array', 'null'],
                        items: {
                            type: ['object', 'null'],
                            properties: {
                                // birthDate must be before claims submitted date
                                birthDate: {
                                    type: ['string', 'null'],
                                    formatMaximum: {
                                        $data: '3/indicator/claimReceivedDate',
                                        customErrorMessage: constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_DATE_PRIOR_CLAIM_SUBMISSION_DATE, 'birthDate'),
                                    },
                                },
                            },
                        },
                    },
                },
            },
        },
        {
            if: {
                required: ['indicator', 'borrowerCharges'],
                properties: {
                    indicator: {
                        required: ['claimReceivedDate'],
                    },
                },
            },
            then: {
                properties: {
                    borrowerCharges: {
                        type: ['array', 'null'],
                        items: {
                            type: ['object', 'null'],
                            properties: {
                                // receivedDate must be before claims submitted date
                                receivedDate: {
                                    type: ['string', 'null'],
                                    formatMaximum: {
                                        $data: '3/indicator/claimReceivedDate',
                                        customErrorMessage: constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_DATE_PRIOR_CLAIM_SUBMISSION_DATE, 'receivedDate'),
                                    },
                                },
                            },
                        },
                    },
                },
            },
        },
        {
            if: {
                required: ['indicator'],
                properties: {
                    indicator: {
                        required: ['claimReceivedDate'],
                    },
                },
            },
            then: {
                required: ['detail'],
                properties: {
                    detail: {
                        type: ['object', 'null'],
                        properties: {
                            // datePaid date must be before claims submitted date
                            datePaid: {
                                type: ['string', 'null'],
                                formatMaximum: {
                                    $data: '2/indicator/claimReceivedDate',
                                    customErrorMessage: constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_DATE_PRIOR_CLAIM_SUBMISSION_DATE, 'datePaid'),
                                },
                            },
                            // informationSentToNationalRecoveriesCentre date must be before claims submitted date
                            informationSentToNationalRecoveriesCentre: {
                                type: ['string', 'null'],
                                formatMaximum: {
                                    $data: '2/indicator/claimReceivedDate',
                                    customErrorMessage: constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_DATE_PRIOR_CLAIM_SUBMISSION_DATE, 'informationSentToNationalRecoveriesCentre'),
                                },
                            },
                            // legalActionCompletedDate date must be before claims submitted date
                            legalActionCompletedDate: {
                                type: ['string', 'null'],
                                formatMaximum: {
                                    $data: '2/indicator/claimReceivedDate',
                                    customErrorMessage: constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_DATE_PRIOR_CLAIM_SUBMISSION_DATE, 'legalActionCompletedDate'),
                                },
                            },
                            // legalActionStartedDate date must be before claims submitted date
                            legalActionStartedDate: {
                                type: ['string', 'null'],
                                formatMaximum: {
                                    $data: '2/indicator/claimReceivedDate',
                                    customErrorMessage: constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_DATE_PRIOR_CLAIM_SUBMISSION_DATE, 'legalActionStartedDate'),
                                },
                            },
                            // offerAcceptedDate date must be before claims submitted date
                            offerAcceptedDate: {
                                type: ['string', 'null'],
                                formatMaximum: {
                                    $data: '2/indicator/claimReceivedDate',
                                    customErrorMessage: constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_DATE_PRIOR_CLAIM_SUBMISSION_DATE, 'offerAcceptedDate'),
                                },
                            },
                            // propertyVacancyDate date must be before claims submitted date
                            propertyVacancyDate: {
                                type: ['string', 'null'],
                                formatMaximum: {
                                    $data: '2/indicator/claimReceivedDate',
                                    customErrorMessage: constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_DATE_PRIOR_CLAIM_SUBMISSION_DATE, 'propertyVacancyDate'),
                                },
                            },
                            // receivedDeficiencySaleClosingDate date must be before claims submitted date
                            receivedDeficiencySaleClosingDate: {
                                type: ['string', 'null'],
                                formatMaximum: {
                                    $data: '2/indicator/claimReceivedDate',
                                    customErrorMessage: constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_DATE_PRIOR_CLAIM_SUBMISSION_DATE, 'receivedDeficiencySaleClosingDate'),
                                },
                            },
                            // receivedLenderNotificationDate date must be before claims submitted date
                            receivedLenderNotificationDate: {
                                type: ['string', 'null'],
                                formatMaximum: {
                                    $data: '2/indicator/claimReceivedDate',
                                    customErrorMessage: constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_DATE_PRIOR_CLAIM_SUBMISSION_DATE, 'receivedDeficiencySaleClosingDate'),
                                },
                            },
                        },
                    },
                },
            },
        },
        {
            if: {
                required: ['indicator'],
                properties: {
                    indicator: {
                        required: ['claimReceivedDate'],
                    },
                },
            },
            then: {
                //  approvedDate must be before claims submitted date
                required: ['defaultManagement'],
                properties: {
                    defaultManagement: {
                        type: ['object', 'null'],
                        properties: {
                            approvedDate: {
                                type: ['string', 'null'],
                                formatMaximum: {
                                    $data: '2/indicator/claimReceivedDate',
                                    customErrorMessage: constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_DATE_PRIOR_CLAIM_SUBMISSION_DATE, 'approvedDate'),
                                },
                            },
                        },
                    },
                },
            },
        },
        {
            if: {
                required: ['detail', 'partialPayments'],
                properties: {
                    detail: {
                        required: ['receivedLastCompleteInstallmentPaidDueDate'],
                    },
                },
            },
            then: {
                // receivedDate has to be after receivedLastCompleteInstallmentPaidDueDate
                properties: {
                    partialPayments: {
                        type: ['array', 'null'],
                        items: {
                            type: ['object', 'null'],
                            properties: {
                                receivedDate: {
                                    type: ['string', 'null'],
                                    formatMinimum: {
                                        $data: '3/detail/receivedLastCompleteInstallmentPaidDueDate',
                                        customErrorMessage: constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_PARTIAL_PAYMENTS_0, 'receivedDate'),
                                    },
                                },
                            },
                        },
                    },
                },
            },
        },
        {
            if: {
                required: ['detail', 'exceptionToListingFlag'],
                properties: {
                    exceptionToListingFlag: {
                        enum: [false, 'false'],
                    },
                    detail: {
                        type: ['object', 'null'],
                        required: ['claimTypeCode'],
                        properties: {
                            claimTypeCode: {
                                const: constants_2.ClaimTypeCode.DeficiencySale,
                            },
                        },
                    },
                },
            },
            then: {
                if: {
                    properties: {
                        detail: {
                            required: ['propertySoldByTypeCode'],
                            properties: {
                                propertySoldByTypeCode: {
                                    const: constants_2.PropertySoldBy.ByApprovedLender,
                                },
                            },
                        },
                    },
                },
                then: {
                    required: ['listings'],
                    properties: {
                        listings: {
                            items: {
                                required: ['minimumAcceptableSalePriceAmount'],
                            },
                        },
                    },
                },
            },
        },
        {
            if: {
                properties: {
                    partialPaymentReceivedFlag: {
                        enum: [true, 'true'],
                    },
                },
            },
            then: {
                required: ['partialPayments'],
                properties: {
                    partialPayments: {
                        type: 'array',
                        minItems: 1,
                        items: partial_payment_1.partialPaymentsExtendedSchema,
                        isAfterClaimReceivedDate: {
                            $data: '1/indicator/claimReceivedDate',
                        },
                    },
                },
            },
            else: {
                properties: {
                    partialPayments: {
                        type: 'null',
                    },
                },
            },
        },
        {
            if: {
                properties: {
                    rentalIncomeReceivedFlag: {
                        enum: [true, 'true'],
                    },
                },
            },
            then: {
                required: ['netOperatingIncomesRentalIncomes'],
                properties: {
                    netOperatingIncomesRentalIncomes: {
                        type: 'array',
                        minItems: 1,
                        items: net_operating_income_rental_income_1.netOperatingIncomeRentalIncomeSchema,
                    },
                },
            },
            else: {
                properties: {
                    netOperatingIncomesRentalIncomes: {
                        type: 'null',
                    },
                },
            },
        },
        {
            if: {
                required: ['detail', 'exceptionToListingFlag'],
                properties: {
                    exceptionToListingFlag: {
                        enum: [false, 'false'],
                    },
                    detail: {
                        type: ['object', 'null'],
                        required: ['claimTypeCode'],
                        properties: {
                            claimTypeCode: {
                                not: {
                                    enum: [constants_2.ClaimTypeCode.EnhancedClaimService, constants_2.ClaimTypeCode.WalkAway],
                                },
                            },
                        },
                    },
                },
            },
            then: {
                // Additional fields in listing are mandatory when exceptionToListingFlag is false
                properties: {
                    listings: {
                        type: 'array',
                        items: listing_1.listingAdditionalMandatoryFieldsSchema,
                        minItems: 1,
                        isAfterFirstListingDate: ['appraisalDate', 'comparativeMarketAnalysisDate', 'date'],
                        isLessThanFirstListingAmount: ['revisedPriceAmount'],
                    },
                },
            },
        },
        {
            if: {
                required: ['detail'],
                properties: {
                    detail: {
                        type: ['object', 'null'],
                        required: ['claimTypeCode'],
                        properties: {
                            claimTypeCode: {
                                const: constants_2.ClaimTypeCode.DeficiencySale,
                            },
                        },
                    },
                },
            },
            then: {
                properties: {
                    detail: __assign(__assign({}, detail_1.detailExtendedSchema), { required: __spreadArrays(detail_1.detailExtendedSchema.required, ['receivedDeficiencySaleClosingDate']) }),
                },
            },
        },
    ],
};
exports.getSubmittedClaimSchema = function () {
    return new schema_validator_1.SchemaValidator(exports.submittedClaimSchema, true, false, true, true);
};
